import React from 'react';
import { Compass } from 'lucide-react';
import { Modal } from './ui/Modal';

interface TourStartConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const TourStartConfirmModal: React.FC<TourStartConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="flex flex-col items-center text-center gap-4 pt-2">
        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-navy-100">
          <Compass className="text-gold-600" size={24} />
        </div>

        <div>
          <h3 className="text-lg font-semibold text-gray-900 mb-1">
            Reset calculator to start the tour?
          </h3>
          <p className="text-sm text-gray-500">
            The guided tour needs two scenario tabs and works best from a clean starting point. Your
            calculator will be reset to the <span className="font-medium text-gray-700">Custom</span>{' '}
            preset (two default comparison tabs). If you continue, your current single-tab work will be
            replaced. You can cancel and keep editing.
          </p>
        </div>

        <div className="flex gap-3 w-full pt-2">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500 transition-colors"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="flex-1 px-4 py-2 text-sm font-medium text-white bg-amber-600 border border-transparent rounded-md hover:bg-amber-700 focus:outline-none focus:ring-2 focus:ring-amber-500 transition-colors"
          >
            OK
          </button>
        </div>
      </div>
    </Modal>
  );
};
